module.exports = __webpack_public_path__ + "static/media/create_account.45253d96.png";